/* all these are dynamic, add the required route for each page */
// import {pagesRoutes as XrsBTrxRoute} from '../pages/XrsBTrx/index'
// import {pagesRoutes as SqlReportRoute} from '../pages/SqlReport/index'
import {pagesRoutes as AccountRoute} from '../pages/Account/index'
import {pagesRoutes as HomeRoute} from '../pages/CmnBlog/index'

export default [
    // ...XrsBTrxRoute,
    // ...SqlReportRoute,
    ...AccountRoute,
    ...HomeRoute
]


// WEBPACK FOOTER //
// ./src/app/route.js